import { Component, OnInit, Self } from '@angular/core';
import { forkJoin, of } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { Transition } from '@uirouter/angular';

import { NgOnDestroy } from '@app/shared/services/ng-on-destroy.service';
import { UserResource } from '@app/shared/modules/resources/user.resource';

import { AuthService } from '@app/shared/services/auth.service';
import { BackgroundBrandedService } from '@app/shared/modules/background-branded/services/background-branded.service';

@Component({
  providers: [NgOnDestroy],
  selector: 'app-email-change-confirmation',
  templateUrl: './email-change-confirmation.component.html',
  standalone: false
})
export class EmailChangeConfirmationComponent implements OnInit {
  isLoaded = false;

  delay = 5; // Seconds
  status = '';

  constructor(
    @Self() private destroy: NgOnDestroy,
    private Auth: AuthService,
    private backgroundBrandedService: BackgroundBrandedService,
    private transition: Transition,
    private userResource: UserResource
  ) {}

  ngOnInit(): void {
    const { u: id, t: token } = this.transition.params();

    forkJoin({
      confirmation: this.userResource.confirmEmailChange(id, { token }).pipe(catchError(err => of(err))),
      branding: this.backgroundBrandedService.fetchBranding().pipe(catchError(_ => of(null)))
    })
      .pipe(takeUntil(this.destroy))
      .subscribe(({ confirmation }) => {
        this.status = confirmation?.status >= 300 ? 'error' : 'success';
        this.isLoaded = true;

        if (this.status === 'success') {
          setTimeout(() => {
            this.login();
          }, this.delay * 1000);
        }
      });
  }

  login() {
    this.Auth.endSession();
  }
}
